// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
    }
};

var bcSfFilterTemplate = {
    'saleClass': 'on-sale',
    'soldOutClass': 'sold-out',
    'blockLayoutClass': 'ft ftw ft-nm',

    'saleLabelHtml': '<span class="product-label sale"><span>' + bcSfFilterConfig.label.sale + '</span></span>',
    'soldOutLabelHtml': '<span class="product-label soldout"><span>' + bcSfFilterConfig.label.soldout + '</span></span>',

    // Grid Template
    'productGridItemHtml':  '<div class="product-block {{soldOutClass}} flex column {{maxColsClass}} min-cols-2 {{itemGridWidthClass}}">' +
                                '<div class="image">' +
                                    '<div class="inner">' +
                                        '<a href="{{itemUrl}}">' +
                                            '{{itemImg}}' +
                                        '</a>' +
                                        '{{itemQuickView}}' +
                                    '</div>' +
                                    '{{itemLabels}}' +
                                '</div>' +

                                '<div class="chatgpt-grid-price {{saleClass}}">{{itemPrice}}</div>' +
                                '<div class="{{blockLayoutClass}}">' +
                                    '<div class="ftr">' +
                                        '<a class="title ftc" href="{{itemUrl}}">{{itemTitle}}</a>' +
                                    '</div>' +
                                '</div>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}" class="prev"><i class="icon-arrow-left"></i></a></li>',
    'previousDisabledHtml': '<li><span class="linkless prev"><i class="icon-arrow-left"></i></span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}" class="next"><i class="icon-arrow-right"></i></a></li>',
    'nextDisabledHtml': '<li><span class="linkless next"><i class="icon-arrow-right"></i></span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><span class="linkless">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span class="linkless">{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination">{{previous}}{{pageItems}}{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + ':</label><div class="pretty-select id-sort-by"><select class="sort-by">{{sortingItems}}</select><span class="text"><span class="value">{{itemLabelActive}}</span></span><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path><path d="M0-.75h24v24H0z" fill="none"></path></svg></div>',
};

BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add soldOut class
    var soldOutClass = soldOut && bcSfFilterConfig.custom.label_soldout_enable ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // Add maxColsClass
    itemHtml = itemHtml.replace(/{{maxColsClass}}/g, 'max-cols-' + bcSfFilterConfig.custom.products_per_row);

    // Add itemGridWidthClass
    var itemGridWidthClass = ''
    if (index % 2 == 1) { itemGridWidthClass += 'nth-2 '; }
    if (index % 3 == 1) { itemGridWidthClass += 'nth-3 '; }
    if (index % 4 == 1) { itemGridWidthClass += 'nth-4 '; }
    if (index % 6 == 1) { itemGridWidthClass += 'nth-6 '; }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Add Block layout class
    var blockLayoutClass = bcSfFilterConfig.custom.block_layout == 'beside' ? bcSfFilterTemplate.blockLayoutClass : '';
    itemHtml = itemHtml.replace(/{{blockLayoutClass}}/g, blockLayoutClass);

    // Add price
    var itemPriceHtml = '';
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    if (priceVaries) {
//        itemPriceHtml += bcSfFilterConfig.label.from_price + ' ';		  // commented by MLveda
    }
    itemPriceHtml += '<span class="amount">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
    if (onSale) {
        itemPriceHtml += ' <del>' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</del>';
    }
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Labels
    var itemLabelsHtml = '';
    if (onSale && bcSfFilterConfig.custom.label_sale_enable) {
        itemLabelsHtml += bcSfFilterTemplate.saleLabelHtml;
    } else if (bcSfFilterConfig.custom.label_remain_show && data.variants.length == 1 && data['variants'][0].length  > 0 && data['variants'][0].inventory_quantity > 0 && data['variants'][0].inventory_quantity < bcSfFilterConfig.custom.prod_stock_warn_limit) {
        itemLabelsHtml += '<span class="product-label general"><span>' + bcSfFilterConfig.label.only_x_left.replace(/{{ quantiy }}/g, data['variants'][0]['inventory_quantity']) + '</span></span>';
    } else {
        if (soldOut && bcSfFilterConfig.custom.label_soldout_enable) {
            itemLabelsHtml += bcSfFilterTemplate.soldOutLabelHtml;
        } else {
            for (var k in data.tags) {
                var tag = data['tags'][k];
                if (tag.indexOf('meta-label-') > -1) {
                    itemLabelsHtml += '<span class="product-label general"><span>' + tag.replace('meta-label-', '') + '</span></span>';
                }
            }
        }
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Thumbnail
    // var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '600x') : bcSfFilterConfig.general.no_image_url;
    // itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Quickview
    var itemQuickViewHtml = '';
    if (bcSfFilterConfig.custom.prod_quick_buy_show) {
        itemQuickViewHtml += '<div class="quick-buy-wrap pos-' + bcSfFilterConfig.custom.prod_quick_buy_pos + '">';
        itemQuickViewHtml += '<a class="quick-buy ';
        itemQuickViewHtml += bcSfFilterConfig.custom.prod_quick_buy_pos == 'middle' ? 'giant' : 'big';
        itemQuickViewHtml += '-round-button" href="{{itemUrl}}">' + bcSfFilterConfig.label.quick_view + '</a>';
        itemQuickViewHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    //Add Image
    var itemImgHtml = '';
    var aspect_ratio = images[0]['width'] / images[0]['height'];
    var cover = false;
    itemImgHtml += '<div class="reveal">';
    itemImgHtml +=  '<div class="rimage-outer-wrapper" style="max-width:' + images[0]['width'] + 'px">' +
                        '<div class="rimage-wrapper lazyload--placeholder" style="padding-top:' + 1 / aspect_ratio * 100 + '%">' +
                            '<img class="rimage__image lazyload fade-in" data-src="' + this.getFeaturedImage(images, '{width}x') + '" ' + 
                                'data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="' + aspect_ratio + '" ' +
                                'data-sizes="auto" alt="{{itemTitle}}"' +
                            '/>' +
                        '</div>' +
                    '</div>' + 
                    '<noscript>' +
                        '<img src="' + this.getFeaturedImage(images, '1024x1024') + ' alt="{{itemTitle}}" class="rimage__image"/>' + 
                    '</noscript>';
    if (images.length > 1) {
        itemImgHtml += '<img class="hidden" src="' + images[1].src + '" alt="{{itemTitle}}" />' ;
    }                
    itemImgHtml += '</div>';
    itemHtml = itemHtml.replace(/{{itemImg}}/g, itemImgHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));



    return itemHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  
    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            html = html.replace(/{{itemLabelActive}}/g, sortingArr[this.queryParams.sort]);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function() {
    // Add content for Quick view
    jQ('.product-block').each(function() {
        var _this = this;
        var url = jQ(this).find("a").eq(0).attr("href");
        jQ.ajax({
            type: "GET",
            url: url + '?view=bc-sf-quickview',
            success: function(data){
                jQ(_this).append(data);
            }
        });
    })
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    // Display number of products
    jQ('.results-count').html(bcSfFilterConfig.label.products_count.replace(/{{ count }}/g, data.total_product));
  if("undefined" != typeof checkShopifyFormatMoney){
  $m("<style type=\"text/css\">span.money{ display: none; }</style>").appendTo("head");
  checkShopifyFormatMoney();
  }
}


// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; if(data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0){ data[k].tags = data[k]['original_tags'].slice(0); }} return data };

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */
/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */

/* ChatGPT 123KLAN sale/order patch - All available products only */
(function(){
 var cid="60173353025",sale={
 "bandit1sm-logo-snapback-hat-black":["20.00","40.00",1],
 "bandit1sm-logo-snapback-hat-black-copie":["20.00","40.00",2],
 "mascot-123klan-mr-card-tee":["18.50","37.00",3],
 "oh-merde-baseball-t-shirt":["21.00","42.00",4],
 "pom-beanie-bandit1sm-black":["12.45","24.90",5],
 "pom-beanie-bandit1sm-navy-red":["16.00","32.00",6]};
 function fix(){
  if(!window.bcSfFilterConfig||String(bcSfFilterConfig.general.collection_id)!==cid)return;
  var g=document.getElementById("bc-sf-filter-products");if(!g)return;
  var cs=[].slice.call(g.querySelectorAll(".product-block"));
  cs.forEach(function(c){var a=c.querySelector('a[href*="/products/"]');if(!a)return;var m=a.getAttribute("href").match(/\/products\/([^?\/]+)/);if(!m)return;var p=sale[m[1].toLowerCase()];if(!p)return;c.setAttribute("data-sale-rank",p[2]);var e=c.querySelector(".chatgpt-grid-price");if(e){e.className="chatgpt-grid-price on-sale";e.innerHTML="<del>$"+p[1]+"</del> <span class=\"amount\">$"+p[0]+"</span>";}});
  cs.filter(function(c){return c.getAttribute("data-sale-rank");}).sort(function(a,b){return +a.getAttribute("data-sale-rank")-+b.getAttribute("data-sale-rank");}).reverse().forEach(function(c){g.insertBefore(c,g.firstChild);});
 }
 document.addEventListener("DOMContentLoaded",fix);window.addEventListener("load",fix);setInterval(fix,700);
})();